function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import styles from "./styles.css";
import { Picture, Source, Img } from "@xo-union/tk-component-picture";
import Loading from "./Loading.js";
var DesignerCard = function DesignerCard(_ref) {
  var designer = _ref.designer,
    index = _ref.index,
    imageProps = _ref.imageProps,
    onClick = _ref.onClick;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loaded = _useState2[0],
    setLoaded = _useState2[1];
  var _useState3 = useState(window.innerWidth),
    _useState4 = _slicedToArray(_useState3, 2),
    windowWidth = _useState4[0],
    setWindowWidth = _useState4[1];
  var smallDevice = windowWidth <= 480;
  var isMobile = windowWidth <= 768;
  var handleImageLoad = function handleImageLoad() {
    setLoaded(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.cardContainer,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("a", {
    className: "panel-image photo-card anchor-card-".concat(index),
    position: index + 1,
    href: "".concat(designer.attributes.slug, "-wedding-dresses"),
    style: {
      display: loaded ? "block" : "none"
    }
  }, /*#__PURE__*/React.createElement(Picture, {
    env: "production",
    id: designer.attributes.imageUuid,
    pixelDensities: [1, 2],
    lazy: imageProps.lazy,
    showSpinner: imageProps.show_spinner
  }, /*#__PURE__*/React.createElement(Source, {
    viewport: "md",
    width: imageProps.width,
    height: imageProps.height,
    smartCrop: imageProps.smartCrop
  }), /*#__PURE__*/React.createElement(Source, {
    viewport: "xs",
    width: imageProps.width,
    height: imageProps.height,
    smartCrop: imageProps.smartCrop
  }), /*#__PURE__*/React.createElement(Img, {
    pixelDensity: 1,
    className: styles.designerCardImage,
    alt: designer.attributes.name,
    smartCrop: imageProps.smartCrop,
    resize: [530, 276],
    lazy: imageProps.lazy,
    width: imageProps.width,
    height: imageProps.height,
    onLoad: handleImageLoad
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.collectionName
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.designerName
  }, designer.attributes.name), /*#__PURE__*/React.createElement("span", {
    className: styles.hubLink
  }, "View collection"))), /*#__PURE__*/React.createElement(Loading, {
    isMobile: isMobile,
    smallDevice: smallDevice,
    loaded: loaded
  }));
};
export default DesignerCard;